/* eslint-disable no-underscore-dangle */
import { filter as _filter, isString, trim } from 'lodash';
import moment from 'moment-timezone';
import { equals, pathOr, compose, merge, omit, length, __, gt, filter } from 'ramda';
import { isNilOrEmpty } from 'ramda-adjunct'
import React from 'react';
import API, { axiosGet } from 'src/api/api';
import accountService from 'src/services/account.service';
import Api from './components/form-field-types/appointment-booking/api';

import { AppointmentBookingUUID, PatientField } from 'src/components/FormBuilder/forms/components/form-field-types/appointment-booking/constants';
import { sortProviders } from '../../FormBuilder/forms/components/form-field-types/appointment-booking/utils'
import ConfirmationDialog from 'src/components/ConfirmationDialog/ConfirmationDialog';
import { APP_CONSTANT } from 'src/constants';
import { AppContext } from 'src/context/AppContextProvider';
import { withCookies } from 'react-cookie';
import PrimaryButton from 'src/components/PrimaryButton/PrimaryButton.component';
import {
  fieldIsType,
  getComponent,
  getGoogleReserveQueryParameters,
  getFieldProperties,
  getFieldPropertyValues,
  getMapFromArray,
  hasFieldByName,
  hasSubfields,
  httpRequest,
  getUTMQueryStringParameters,
  getUTMCookieParameters,
  GoogleReserveQueryParamKeys,
  Messages
} from './components/form-field-types/helpers';
import {
  LIST_PREPOPULATE_FIELDS_FOR_PATIENT_FORMS,
  LIST_BASIC_FIELD_TYPE,
  CONTACT_FIELDS,
  getBasicFieldType,
  getFieldValueMapper,
  canPrepopulateInInitialPatientForm,
  canPrepopulateInOtherForms
} from './constants';
import './form-renderer.scss';
import { default as safeAttributes } from './form-submission-attributes';
import { validateField, validateMobileConsentField } from './form-validate';
import ThankYou from './thank-you';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import { t } from 'src/i18n';
import { AppointmentTimeValidationMessage } from './components/form-field-types/appointment-booking/constants';
import ErrorImg from 'src/assets/icons/error.png';
import { parseJSON, getRelationship, normalizeContactAttributes } from 'src/utils/common.util';
import { USER_SERVICE_ROOT, ACCOUNT_SERVICE_ROOT } from 'src/constants/app.constant';
import { FormFieldInputTypeEnum } from './components/form-field-types/form-field-input';

const reloadPage = () => window.location.reload();

const ErrorMessages = {
  FORM_RETRIEVAL_ERROR:
    'There was an issue loading this form. Please refresh your browser to try again.',
  FORM_SUBMISSION_ERROR:
    'We were unable to process this submission. Please check your entries and try again.',
  SUBMISSION_RETRIEVAL_ERROR:
    'There was an issue loading your previous submission for this form. Please refresh your browser to try again.',
  CONTACT_US: `Please contact us if the problem persists. We apologize for the inconvenience.`
};

const TIME_NOON = '12:00:00';

class FormRenderer extends React.Component {
  constructor(props) {
    super(props);

    const cookies = this.props.cookies.getAll();

    this.state = {
      formVersion: null,
      fields: {},
      pages: [],
      page: 1,
      formErrors: 0,
      isSaving: false,
      dataProcessingError: null,
      errorConfirmationAction: null,
      submitted: false,
      isShow: false,
      familyMemberList: [],
      thankYouMessage: null,
      isLoadingPatientInfo: false,
      ownerId: this.props.ownerId,
      userInfo: {
        ...cookies.userInfo,
        ...cookies.guardian,
        spouse: cookies.spouse,
        billing: cookies.billing,
        primaryInsurance: cookies.primaryInsurance,
        secondaryInsurance: cookies.secondaryInsurance,
      },
      isConfirmedUsingLatestUserInfo: false,
      showConfirmUsingLatestUserInfo: false,
      submitLoading: false,
      updatedAppointmentBookingSlots: [],
      oabSubmissionConflictError: 0,
      availableSlotTime: null,
      isFeatureFlagEnabled: false,
      isResetOabForm: false,
      activeOABTab: null,
      generalSettingParams: null,
      isApproved: false
    };
    const {
      id: formId,
      checksum: formChecksum,
      submissionId,
      submissionChecksum,
      saveAsGuest,
      type
    } = props;

    const tenantInfo = parseJSON('tenantInfo');

    this.formId = formId;
    this.formChecksum = formChecksum;
    this.token = this.props.cookies.getAll().token;
    this.role = this.props.cookies.getAll().role;

    this.saveAsGuest = saveAsGuest;
    this.type = type;
    this.isLoggedIn = [
      APP_CONSTANT.ROLE_SINGLE_USER,
      APP_CONSTANT.ROLE_LEGAL_GUARDIAN
    ].includes(this.role);
    this.subDomain = this.role ? `${USER_SERVICE_ROOT}` : `${USER_SERVICE_ROOT}/public`;
    this.submissionsUrl = `${this.subDomain}/submissions/${submissionId}${submissionChecksum ? `/${submissionChecksum}` : ''}${!this.isLoggedIn ? `?accountId=${tenantInfo.accountId}` : ''}`; // eslint-disable-line no-undef
    this.formsUrl = `${this.subDomain}/forms/${formId}${formChecksum ? `/${formChecksum}` : ''}${!this.isLoggedIn ? `?accountId=${tenantInfo.accountId}` : ''}`; // eslint-disable-line no-undef
    this.submitFormsUrl = `${USER_SERVICE_ROOT}/public/forms/${formId}${formChecksum ? `/${formChecksum}` : ''}${!this.isLoggedIn ? `?accountId=${tenantInfo.accountId}` : ''}`; // eslint-disable-line no-undef
    this.saveAsGuest = saveAsGuest;
    this.type = type;
    this.latestUserInfo = {};
  }

  static contextType = AppContext;

  isPatientForm = () => this.type !== APP_CONSTANT.APPOINTMENT_BOOKING;

  componentDidMount() {
    if (this.isPatientForm()) {
      if (this.isLoggedIn) {
        this.context.setFormState({
          [`${this.props.ownerId}-${this.formId}`]: APP_CONSTANT.PRISTINE
        });
      } else {
        this.context.setFormState({
          [this.formId]: APP_CONSTANT.PRISTINE
        });
      }
    }

    if ([
      APP_CONSTANT.ROLE_SINGLE_USER,
      APP_CONSTANT.ROLE_LEGAL_GUARDIAN
    ].includes(this.props.cookies.getAll().role)) {
      const cookies = this.props.cookies.getAll();

      const userInfo = {
        ...cookies.userInfo,
        ...cookies.guardian,
        spouse: cookies.spouse,
        billing: cookies.billing,
        primaryInsurance: cookies.primaryInsurance,
        secondaryInsurance: cookies.secondaryInsurance,
      };

      this.setState(prev => ({ ...prev, userInfo }));
    }
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const incomingCookies = nextProps.cookies.getAll();
    if (incomingCookies.userInfo && [
      APP_CONSTANT.ROLE_SINGLE_USER,
      APP_CONSTANT.ROLE_LEGAL_GUARDIAN
    ].includes(incomingCookies.role) && nextProps.ownerId === incomingCookies.userInfo && incomingCookies.userInfo.id) {
      const incomingUserInfo = {
        ...incomingCookies.userInfo,
        ...incomingCookies.guardian,
        spouse: incomingCookies.spouse,
        billing: incomingCookies.billing,
        primaryInsurance: incomingCookies.primaryInsurance,
        secondaryInsurance: incomingCookies.secondaryInsurance
      }
      if (!equals(incomingUserInfo, this.state.userInfo)) {
        this.latestUserInfo = incomingCookies.userInfo;

        this.setState({
          showConfirmUsingLatestUserInfo: true,
        });
      }
    }

  }


  async componentDidUpdate(prevProps) {
    if (this.shouldLoadData(prevProps)) this.loadData();
    if (this.isSaving()) this.handleGetSubmission();
    if (this.state.isConfirmedUsingLatestUserInfo) {
      this.setState(prev => ({
        ...prev,
        userInfo: this.latestUserInfo
      }));

      this.loadData();
      this.setState({
        isConfirmedUsingLatestUserInfo: false,
        showConfirmUsingLatestUserInfo: false
      });


    }
  }
  async validateOABSubmissionConflict(inputs) {
    return new Promise(async (resolve, reject) => {
      const time = inputs[AppointmentBookingUUID.appointmentDateTime].value;
      const locationId =
        inputs[AppointmentBookingUUID.appointmentBookingLocationId].value;
      const providerId =
        inputs[AppointmentBookingUUID.appointmentBookingProviderId].value;
      const appointmentTypeId =
        inputs[AppointmentBookingUUID.appointmentTypeId].value;

      const timeInterval =
        inputs[AppointmentBookingUUID.appointmentTypeId].timeInterval;
      const syncAvailability =
        inputs[AppointmentBookingUUID.appointmentTypeId].syncAvailability;
      const timeZone =
        inputs[AppointmentBookingUUID.appointmentTypeId].timeZone;
      const accountId =
        inputs[AppointmentBookingUUID.appointmentTypeId].accountIdOAB;

      let availableSlotTime = [];
      let slots = [];

      if (time) {
        const selectedTime = moment.tz(time, timeZone).toDate().getTime();
        const virtualCalender = await Api.getVirtualCalenderByLocation(
          accountId,
          appointmentTypeId,
          selectedTime,
          syncAvailability,
          timeInterval,
          locationId
        );
        if (virtualCalender?.days?.length === 1) {
          slots = virtualCalender.days[0].timeSlots;
          if (providerId)
            availableSlotTime = slots.filter(
              (s) =>
                s.startTime === selectedTime &&
                s.locationId === Number(locationId) &&
                s.entityId === Number(providerId)
            );
          else {
            availableSlotTime = slots.filter(
              (s) =>
                s.startTime === selectedTime &&
                s.locationId === Number(locationId)
            );
          }
        }
      }
      this.setState(
        {
          oabSubmissionConflictError: availableSlotTime.length === 0 ? 1 : 0,
          updatedAppointmentBookingSlots: slots,
          availableSlotTime
        },
        () => {
          availableSlotTime.length > 0 ? resolve() : reject();
        }
      );
    });
  }

  getAutoSelectProvider = async (inputs, slots) => {
    const appointmentTypeId =
      inputs[AppointmentBookingUUID.appointmentTypeId].value;
    const syncAvailability =
      inputs[AppointmentBookingUUID.appointmentTypeId].syncAvailability;
    const accountId =
      inputs[AppointmentBookingUUID.appointmentTypeId].accountIdOAB;

    const providerIds = slots.map(s => Number(s.entityId));

    //get Providers
    let providers = await Api.getProviders(
      accountId,
      appointmentTypeId,
      syncAvailability,
      syncAvailability ? this.state?.generalSettingParams?.isAvailProviderCoupled.toString() ?? 'true' : 'true'
    );

    const availableProvider = providers.filter(p => providerIds.includes(Number(p.id)));
    // auto selected ID
    const sortProviderList = sortProviders(
      availableProvider.filter((availableProvider) => availableProvider.id)
    );
    if (sortProviderList.length > 0) {
      return sortProviderList[0].id
    }
    return null;
  };



  hideDialog = () => {
    this.setState({ isShow: false });
  };

  shouldLoadData = (prevProps) => {
    return (

      (!this.state.formVersion && !this.state.dataProcessingError) ||
      (this.hasProp('formVersion') &&
        prevProps.formVersion !== this.props.formVersion)
    );
  };

  isSaving = () => this.canSave() && this.state.isSaving;

  checkPatientHadAnExam = async (patientId) => {
    let isHasAnExam = 'No';

    try {
      const getMetAppoinmentsResponse = await API()
        .get(`/user/v1/family/appointments?includedMe=true&withStatus=met`);

      if (getMetAppoinmentsResponse.data) {
        let allAppoinment = pathOr([], ['data', 'appointments'], getMetAppoinmentsResponse);
        const appointmentResponseForPatient = allAppoinment.find(ap => ap.contactId === patientId);
        if (appointmentResponseForPatient) {
          isHasAnExam = appointmentResponseForPatient.status === 'met' ? 'Yes' : 'No';
        }
      }
      return isHasAnExam;
    } catch (error) {
      isHasAnExam = 'No';
    }

    return isHasAnExam;
  };

  getUserInfo = async (contactId) => {
    if (this.isLoggedIn && contactId) {
      const userInfoRes = await axiosGet(
        `${USER_SERVICE_ROOT}/family/contacts/${contactId}`,
        {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          method: 'GET'
        }
      );

      const userAttributeResponse = await axiosGet(
        `${USER_SERVICE_ROOT}/contacts/${contactId}/attributes?namesFilter=ssn,gender,marital_status,communication_type_preference,referral_type,guarantor,primary_insurance,secondary_insurance`,
        {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          method: 'GET'
        }
      );

      const userAttributes = normalizeContactAttributes(userAttributeResponse.data);

      const guarantors = pathOr([], ['guarantor'], userAttributes);

      const spouse = getRelationship('spouse')(guarantors);
      const guardian_1 = getRelationship('guardian_1')(guarantors);

      const isMoreThanOneGuardianExists = compose(
        gt(__, 1),
        length,
        filter((guarantor) => guarantor.familyAccess && guarantor.relationship === 'Guardian')
      )(guarantors);

      let guardian_2;

      if (isMoreThanOneGuardianExists) {
        guardian_2 = getRelationship('guardian_2', { guardian_1 })(guarantors);
      }
      if (!guardian_2) {
        guardian_2 = getRelationship('guardian_2')(guarantors);
      }

      const billing = getRelationship('billing')(guarantors);

      const primaryInsurance = pathOr({}, ['primary_insurance'], userAttributes);
      const secondaryInsurance = pathOr({}, ['secondary_insurance'], userAttributes);

      const normalizedUserAttributes = compose(
        merge({
          primaryInsurance,
          secondaryInsurance,
          spouse,
          guardian_1,
          guardian_2,
          billing
        }),
        (obj) => omit(['guarantor', 'primary_insurance', 'secondary_insurance'], obj)
      )(userAttributes);

      return {
        ...userInfoRes.data,
        ...normalizedUserAttributes
      };
    }

    return {};
  };

  loadData = async () => {
    const tenantInfo = parseJSON('tenantInfo');
    if (this.isLoggedIn) {
      const featureFlagResponse = await axiosGet(
        `${ACCOUNT_SERVICE_ROOT}public/accounts/${tenantInfo.accountId}/feature-flag?featureFlag=${encodeURIComponent('Patient Forms')}`,
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
          method: 'GET'
        }
      );
      if (featureFlagResponse.status == 200 &&
        featureFlagResponse.data.name == 'Patient Forms' &&
        featureFlagResponse.data.value &&
        featureFlagResponse.data
      ) {
        this.setState({ isFeatureFlagEnabled: true });
      }
    }

    if (this.canSave() && this.props.saveFlag) {
      this.setState({ isSaving: true });
      return;
    }
    const ownerId = this.state.ownerId;

    let formVersion = {};
    let familyMemberList = [];
    let userInfo = {};

    try {
      if (this.isLoggedIn && this.role === APP_CONSTANT.ROLE_LEGAL_GUARDIAN) {
        familyMemberList = await this.loadFamilyMembers();
      }
      if (this.hasProp('formVersion')) {
        formVersion = this.getFormVersionFromProps();
      } else {
        formVersion = this.mapSafeAttributes(
          'formVersion',
          await this.getFormVersionFromHttp()
        );
      }

      userInfo = this.state.userInfo;

      if (ownerId && ownerId !== pathOr('', ['userInfo', 'id'])(this.state)) {
        userInfo = await this.getUserInfo(ownerId);
      }

    } catch (ex) {
      this.setState({
        dataProcessingError: ErrorMessages.FORM_RETRIEVAL_ERROR,
        errorConfirmationAction: reloadPage
      });
    }

    // append patient dropdown for request appoinment booking form when legal guardian is logged in  
    if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
      if (this.role === APP_CONSTANT.ROLE_LEGAL_GUARDIAN) {
        const isPatinetDropdownAvailable = (item) => item.uuid === PatientField.uuid;

        if (!formVersion.object.fields.find(isPatinetDropdownAvailable)) {
          const patientField = { ...PatientField };
          patientField.properties.specific = [
            [
              'placeholder',
              {}
            ],
            ['options', { type: 'option-group', label: 'Options', value: ['', ...familyMemberList.map(m => m.id)] }]
          ];
          formVersion.object.fields.splice(1, 0, patientField);
        }
      }
    }

    const generalSettingParams = await Api.getPatientPortalPublicGeneralSettings(
      tenantInfo.accountId
    );

    const relationshipTypes = await this.loadRelationshipTypes(formVersion.account_id);

    this.saveGoogleReserveToken(generalSettingParams?.googleReserveEnabled);

    // map page breaks to state for use in render()
    // to only display fields for the current page
    const pages = this.mapPageBreaks(formVersion);
    // also map formVersion fields to fields array in state
    const fields = this.loadFieldsToState(
      {},
      this.formVersionFields(formVersion)
    );
    this.setState(
      {
        formVersion,
        fields,
        pages,
        page: 1,
        familyMemberList,
        thankYouMessage: formVersion.thank_you,
        generalSettingParams,
        relationshipTypes,
      },
      () => {
        // if a submission object or id has been provided in props,
        // then load the input fields with submitted values
        this.loadSubmissionData(userInfo);
      }
    );
  };

  loadRelationshipTypes = async (accountId) => {
    let relationshipTypes = [];
    try {
      if (!accountId) {
        throw new Error('No Account Id provided, unable to fetch relationship types');
      }
      relationshipTypes = await accountService.getRelationshipTypes(accountId, { family: true });
    } catch (err) {
      console.log('Error fetching relationship types:', err);
    }
    return relationshipTypes;
  };

  saveGoogleReserveToken = async (googleReserveEnabled) => {
    if (!googleReserveEnabled) {
      return;
    }

    const googleReserverParams = getGoogleReserveQueryParameters();
    const accountId = googleReserverParams[GoogleReserveQueryParamKeys.accountId];
    const token = googleReserverParams[GoogleReserveQueryParamKeys.token];

    if (!accountId || !token) {
      return;
    }

    try {
      await Api.saveToken(accountId, token);
    } catch (err) {
      // don't want to break the UI if the token upsert fails
      // log and eat the error? set it to state then surface it to the user?
      console.log('Error saving Google Reserve token to storage', err);
    }
  };

  getFormVersionFromHttp = () => {
    return new Promise((resolve, reject) => {
      httpRequest(this.formsUrl, (err, data) => {
        if (err) {
          // this wasn't always getting hit when it should ( wrongly captured in next if statement );
          reject(err);
          return;
        }

        if (!data || data.length === 0 || !data[0].hasOwnProperty('object')) {
          reject('Form is in an unexpected format. Unable to render.');
          return;
        }
        resolve(data[0]);
      });
    });
  };

  getFormVersionFromProps = () => {
    const { formVersion } = this.props;
    if (!formVersion) return;

    return {
      object: {},
      ...this.mapSafeAttributes('formVersion', formVersion)
    };
  };

  hasProp = (propName) => this.props[propName] !== undefined;

  loadSubmissionData = (userInfoProps) => {
    if (this.hasProp('submissionId')) {
      this.loadSubmissionDataFromHttp().then(({ isApproved }) => {
        // if user start a form whose submission has been approved
        // then pre-populate latest user info into patient form
        if (this.isLoggedIn && isApproved) {
          this.loadContactData(userInfoProps);
        }
      });
    }

    // if form is appointment booking form
    // and the user role is single
    // then pre-populate latest user info into appoinment booking form
    // OR
    // if the patient forms feature flag is enabled and
    // if user start a new form in patient form 
    // and there is no submission in the past
    // then pre-populate latest user info into patient form
    if (
      this.isLoggedIn &&
      this.type === APP_CONSTANT.APPOINTMENT_BOOKING &&
      this.role === APP_CONSTANT.ROLE_SINGLE_USER ||
      this.state.isFeatureFlagEnabled &&
      this.type !== APP_CONSTANT.APPOINTMENT_BOOKING &&
      !this.hasProp('submissionId')
    ) {
      this.loadContactData(userInfoProps);
    }
  };

  loadSubmissionDataFromHttp = () => {
    const fields = { ...this.state.fields };

    return new Promise((resolve, reject) => {
      httpRequest(this.submissionsUrl, (err, data) => {
        if (err) {
          this.setState({
            dataProcessingError: ErrorMessages.SUBMISSION_RETRIEVAL_ERROR,
            errorConfirmationAction: reloadPage
          });
          reject();
          return;
        }

        if (data && data.object) {

          if (!isNilOrEmpty(data.contact_id) && !this.isLoggedIn) {
            this.setState({
              dataProcessingError: ErrorMessages.SUBMISSION_RETRIEVAL_ERROR,
              errorConfirmationAction: reloadPage
            });
            reject();
            return;
          }

          data.object.forEach(
            (field) => {
              if (fields[field.uuid]) {
                fields[field.uuid].value = field.value
              }
            }
          );
          this.setState(prevState => ({
            fields: {
              ...prevState.fields,
            },
            isApproved: data.is_approved
          }));
          resolve({ isApproved: data.is_approved });
        }
      });
    });
  };

  loadSubmissionDataFromProps = () => {
    const { submission: submissionObject = [] } = this.props;
    const fields = { ...this.state.fields };

    // map submission values to fields
    submissionObject.forEach((submittedField) => {
      const matchedField = this.getFirstMatchedField(fields, submittedField);
      if (matchedField && matchedField.uuid === PatientField.uuid) {
        fields[matchedField.uuid].value = '';
      }

      const hasAnExamField = Object.values(fields).find(field => {
        let propMap = getMapFromArray(field.properties.common);
        let labelProps = propMap.get('label') || {};
        return labelProps.value === 'Has this patient had an exam with us in the past?';
      });
      if (hasAnExamField) {
        fields[hasAnExamField.uuid].value = 'No';
      }
      if (matchedField) {
        fields[matchedField.uuid].value = submittedField.value;
      }
    });

    this.setState({ fields });
  };

  loadContactData = async (userInfo) => {
    const fields = { ...this.state.fields };
    const formName = this.state.formVersion.form_name;

    if (['Medical History', 'Dental History'].includes(formName.trim()) && 
      this.isLoggedIn && 
      userInfo.id && 
      (!this.hasProp('submissionId') || (this.hasProp('submissionId') && this.state.isApproved))
    ) {
      const medicalAttributesRes = await axiosGet(
        `${USER_SERVICE_ROOT}/contacts/${userInfo.id}/attributes?namesFilter=medical`,
        {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          method: 'GET'
        }
      );

      if (medicalAttributesRes.data?.[0]?.value) {
        userInfo.medical = JSON.parse(medicalAttributesRes.data[0].value);
      }
    }

    const mapper = getFieldValueMapper(userInfo);

    Object.keys(fields).forEach((fieldKey) => {
      // pre-populate for appoinment booking form
      if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
        const contactFieldName = `${APP_CONSTANT.APPOINTMENT_BOOKING}.${fields[fieldKey].legwork_column_name}`;
        if (CONTACT_FIELDS.includes(contactFieldName)) {
          mapper[contactFieldName](fields[fieldKey]);
        }
      }

      // pre-populate for patient forms (6 forms which has been)
      if (canPrepopulateInInitialPatientForm(fieldKey, formName)) {
        const fieldType = LIST_PREPOPULATE_FIELDS_FOR_PATIENT_FORMS[fieldKey].type;
        mapper[fieldType](fields[fieldKey]);
      }

      // pre-populate for basic fields in other forms
      if (canPrepopulateInOtherForms(fields[fieldKey], formName)) {
        const fieldType = getBasicFieldType(fields[fieldKey]);
        if (LIST_BASIC_FIELD_TYPE.includes(fieldType)) {
          mapper[fieldType](fields[fieldKey]);
        }
      }
    });

    this.setState({ fields });
  };

  getFirstMatchedField = (fields, fieldToMatch) => {
    const matchedField = fields[fieldToMatch.uuid];

    if (matchedField) return matchedField;

    return this.findFormVersionField(fieldToMatch);
  };

  findFormVersionField = (fieldToMatch) => {
    const allFields = this.formVersionFields();
    return (
      allFields[fieldToMatch.uuid] ||
      this.getMatchingFields(allFields, fieldToMatch)
    );
  };

  getMatchingFields = (fields, fieldToMatch) => {
    // search all top-level (not nested) basic (is_basic = true) fields first, for a match on id,
    // -OR- if still not found, search through fields w/ basic (is_basic = true) subfields
    return (
      this.searchFilteredFields(
        fields,
        fieldToMatch,
        (f) => !hasSubfields(f) && f.is_basic
      ) ||
      this.searchFilteredFields(fields, fieldToMatch, (f) => hasSubfields(f))
    );
  };

  searchFilteredFields = (fields, fieldToMatch, filterFn) => {
    const filteredFields = fields.filter(filterFn);
    let result;

    for (let i = 0; i < filteredFields.length; i++) {
      const field = filteredFields[i];
      if (hasSubfields(field)) {
        result = field.fields.find(
          (f) => f.id === fieldToMatch.id && f.is_basic
        );
      } else {
        result = field.id === fieldToMatch.id ? field : false;
      }
      if (result) break;
    }

    return result;
  };

  mapSafeAttributes = (attributeType, dataObject = {}) => {
    const attributes = safeAttributes[attributeType];
    const result = {};
    attributes.forEach(
      (attribute) => (result[attribute] = dataObject[attribute])
    );

    return result;
  };

  mapPageBreaks = (formVersion) => {
    const pages = [];
    this.formVersionFields(formVersion).forEach((field, index) => {
      if (field.type_name === 'Page Break') {
        const { isForPDF } = this.props;
        if (isForPDF) {
          field.type_name = 'Print Page Break';
        } else {
          pages.push(index);
        }
      }
    });
    return pages;
  };

  loadFieldsToState = (fields, fieldList, parentField) => {
    if (!fieldList) return;

    fieldList.forEach((field) => {
      const hasParent = parentField !== undefined;
      const newField = { ...field };

      if (fieldIsType(field, 'Multiple Choice')) {
        newField.value = this.mapFieldOptions(field);
      } else if (fieldIsType(field, 'Single Choice')) {
        // default to null so no radio options are rendered as selected w/o user input
        newField.value = null;
      } else if (fieldIsType(field, 'Sliding Scale')) {
        // default to 0 because the @mui component doesn't support null/undefined as an initial value
        newField.value = 0;
      } else if (
        fieldIsType(field, 'Dropdown') &&
        !fieldIsType(field, 'Sex', 'display_name')
      ) {
        newField.value = this.getDefaultDropdownValue(field);
      } else if (this.allowsInput(field)) {
        newField.value = '';
        newField.validationMessage = undefined;
      }

      if (hasParent) newField.parent = parentField;

      fields[field.uuid] = newField;

      if (field.fields)
        fields = this.loadFieldsToState(fields, field.fields, field);
    });

    return fields;
  };

  handleChange = async (e, forceValidation, requiredOverride = false) => {
    if (this.isPatientForm()) {
      if (this.isLoggedIn) {
        this.context.setFormState({
          [`${this.props.ownerId}-${this.formId}`]: APP_CONSTANT.DIRTY
        });
      } else {
        this.context.setFormState({
          [this.formId]: APP_CONSTANT.DIRTY
        });
      }
    }

    const {
      id,
      otherEl, // will be undefined if this is NOT an "Other" type input as part of "Single Choice" and "Multiple Choice"
      checked,
      value: targetVal,
      useIndexOverride,
      index: optionIndex,
    } = e.target;
    const fields = { ...this.state.fields }; // better way to spread this to extract the known key (id) from the fields object?
    let value = fields?.[id]?.form_field_type_id === FormFieldInputTypeEnum.Checkbox ? checked : targetVal;

    // pre-populate for request appoinment booking form when the selected patient is changed
    if (id === PatientField.uuid) {
      // pre populate fields
      const patientId = value;
      const patientInfo = this.state.familyMemberList.find(f => f && f.id === patientId);
      if (patientInfo) {
        this.setState({
          ownerId: pathOr('', ['id'], patientInfo)
        });
      }
      ;
      const transformedPatientInfo = {
        id: pathOr('', ['id'], patientInfo),
        name: {
          nameFirst: pathOr('', ['attributes', 'nameFirst'], patientInfo),
          nameLast: pathOr('', ['attributes', 'nameLast'], patientInfo),
          nameMiddle: pathOr('', ['attributes', 'nameMiddle'], patientInfo)
        },
        emailAddress: pathOr('', ['attributes', 'primaryEmail'], patientInfo),
        birthDate: pathOr('', ['attributes', 'birthDate'], patientInfo),
        phoneNumbers: [
          {
            'number': pathOr('', ['attributes', 'primaryPhone'], patientInfo),
            'touchpointTypes': [
              'call'
            ]
          }
        ]
      };

      this.loadContactData(transformedPatientInfo);
    }
    // mapping id vs value 

    // multiple choice field value needs to be in the shape of an array of key<string>:value<bool> objects
    // then update the single value being changed
    if (fieldIsType(fields[id], 'Multiple Choice')) {
      const values = [...fields[id].value];
      const valueIndex = useIndexOverride
        ? optionIndex
        : values.findIndex(
          (val) => Object.keys(val)[0] === Object.keys(value)[0]
        );

      // if no previous value then add the value, can occur when editing
      // a form submission with the previous submission was created prior
      // to the new Multiple Choice option being added
      if (valueIndex === -1) {
        values.push(value);
      } else {
        values[valueIndex] = value;
      }

      value = values;
    }

    if (otherEl) {
      otherEl.checked =
        (typeof value === 'object' ? Object.values(value)[0] : value) !== false;
    }

    fields[id].value = value;

    this.setState(
      {
        fields
      },
      () => {
        if (this.state.submissionAttempted) {
          const inputs = this.getFormInputs();
          if (fieldIsType(fields[id], 'Appointment Booking', 'group_name')) {
            const updatedFields = { ...this.state.fields };
            // reset errors message
            if (fields[id].display_name === 'Appointment Date' && fields[id].value === null) {
              updateFieldValidation(updatedFields, fields[id], 'Appointment Date can\'t be blank'); // is a mutator;
            } else if (fields[id].display_name === 'Appointment Time' && (fields[id].value === null || fields[id].value === "")) {
              updateFieldValidation(updatedFields, fields[id], 'Please select a time for your appointment.'); // is a mutator;
            } else if (fields[id].display_name === 'Appointment Type' && (fields[id].value === null || fields[id].value === "")) {
              updateFieldValidation(updatedFields, fields[id], 'Appointment Type can\'t be blank'); // is a mutator;
            } else {
              updateFieldValidation(updatedFields, fields[id], undefined); // is a mutator;
            }

            const formErrors = this.getFormErrorCount(updatedFields)
            this.setState({
              fields: updatedFields,
              formErrors,
              oabSubmissionConflictError: formErrors > 0 ? 0 : this.state.oabSubmissionConflictError
            });
            return;
          }

          return this.validateAllInputs(inputs)
            .then(() => {
              return;
            })
            .catch(() => {
              return;
            });
        }

        forceValidation && this.handleBlur(e, requiredOverride);
      }
    );
  };

  handleReset = () => {
    const fields = { ...this.state.fields };
    Object.keys(fields).forEach((key) => {
      const newField = { ...fields[key] };
      newField.value = '';
      newField.validationMessage = undefined;
      fields[key] = newField;
    });
    this.setState({ fields, formErrors: 0, oabSubmissionConflictError: 0, submissionAttempted: false, isResetOabForm: true }, () => {
      this.setState({ isResetOabForm: false });
    });
  }

  handleOabTab = (activeOABTab) => {
    this.setState({
      activeOABTab
    })
  }

  handleSubmit = async () => {
    const inputs = this.getFormInputs();

    const ownerId = this.state.ownerId;
    this.setState({ submissionAttempted: true });

    await this.validateAllInputs(inputs);

    // Fix for checkboxes not registering a value to our forms if they haven't been interacted with
    Object.keys(inputs).forEach(fieldId => {
      const input = inputs[fieldId];
      if (input.form_field_type_id === FormFieldInputTypeEnum.Checkbox) {
        input.value = input.value ? input.value : false;
      }
    })

    if (this.state.formErrors) return;

    if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
      const syncAvailability =
        inputs[AppointmentBookingUUID.appointmentTypeId].syncAvailability;
      
      if (syncAvailability === 'false') {
        await this.validateOABSubmissionConflict(inputs);

        if (this.state.oabSubmissionConflictError > 0) return;
      }
    }

    const { formVersion } = this.state;

    const submissionObject = this.getSubmissionObject(inputs);
    const utmParameters = this.getUTMParametersObject();

    if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
      const providerField = submissionObject.filter(item => item.legwork_column_name === 'appointment_booking_provider_id' && !item.value);
      const isAutoSelectProviderField = submissionObject.filter(item => item.legwork_column_name === 'is_autoselect_provider');
      
      submissionObject[submissionObject.indexOf(isAutoSelectProviderField[0])].value = false;

      // If provider ID not selected then assign auto selected ID
      if (providerField.length === 1) {
        const uuid = providerField[0].uuid;
         // Assign next available Provider
         if (this.state.updatedAppointmentBookingSlots.length > 0) {
          const providerAutoId = await this.getAutoSelectProvider(inputs, this.state.availableSlotTime)
          submissionObject[submissionObject.indexOf(providerField[0])].value = `${providerAutoId}`;
        } else {
          submissionObject[submissionObject.indexOf(providerField[0])].value = inputs[uuid].providerAutoId;
          submissionObject[submissionObject.indexOf(isAutoSelectProviderField[0])].value = true;
        }
      }

      const patientFieldIndex = submissionObject.findIndex((item) => {
        return item.uuid === { ...PatientField }.uuid;
      });

      if (patientFieldIndex !== -1) {
        submissionObject.splice(patientFieldIndex, 1);
      }
    }

    const submission = this.mapSafeAttributes('submission', {
      ...formVersion,
      object: submissionObject,
      utm_parameters: utmParameters,
      submitted_by: ownerId || '',
      contact_id: ownerId || ''
    });

    const dateColumns = ['birthdate'];

    function isValidDateTimeFormat(dateTimeString) {
      const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/;
      return regex.test(dateTimeString);
    }

    function isValidDateTimeFormatWithTz(dateTimeString) {
      const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}([-+]\d{2}:\d{2})$/;
      return regex.test(dateTimeString);
    }

    submission.object.map((item) => {
      if (dateColumns.includes(item.legwork_column_name)) {
        if (item.value instanceof Date) {
          if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
            item.value = item.value.toISOString().split('T')[0] + 'T' + TIME_NOON;
          } else {
            let tzOffset = (new Date()).getTimezoneOffset() * 60000;
            let localISOTime = (new Date(new Date(item.value).getTime() - tzOffset)).toISOString();
            item.value = localISOTime;
          }
        } else if (isValidDateTimeFormat(item.value) && this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
          item.value = item.value.split('T')[0] + 'T' + TIME_NOON;
        } else if (isValidDateTimeFormatWithTz(item.value) && this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
          item.value = moment(item.value).utc().format('YYYY-MM-DD') + 'T' + TIME_NOON;
        }
      }

      if (isString(item.value)) {
        item.value = trim(item.value);
      }

      return item;
    });

    const practiceSettings = await Api.getRegisterAddress(submission.account_id)

    const { timezone } = practiceSettings;

    const dateFieldIndex = submission.object.findIndex(item => item.legwork_column_name === 'appointment_date');
    const timeFieldIndex = submission.object.findIndex(item => item.legwork_column_name === 'appointment_time');

    if (dateFieldIndex !== -1 && timeFieldIndex !== -1) {
      const date = moment(
        submission.object[dateFieldIndex].value
      );

      const time = moment(
        submission.object[timeFieldIndex].value
      );

      // Construct a Moment date/time object in the practice's timezone (America/Los_Angeles, in this case)
      const dateInPracticeTimezone = moment.tz(
        {
          year: date.year(),
          month: date.month(),
          day: date.date(),

          hour: time.hour(),
          minute: time.minute(),
          second: time.second(),
        },
        timezone
      );

      submission.object[timeFieldIndex].value = dateInPracticeTimezone;
    }

    this.setState(() => ({ submitLoading: true }))

    httpRequest(
      this.submitFormsUrl,
      (err, _data) => {
        const nextState = {};

        if (err) {
          nextState.dataProcessingError = ErrorMessages.FORM_SUBMISSION_ERROR;
          nextState.errorConfirmationAction = reloadPage
        } else {
          this.setState(() => ({ submitLoading: false }))
          if (this.isPatientForm()) {
            if (this.isLoggedIn) {
              this.context.setFormState({
                [`${this.props.ownerId}-${this.formId}`]: APP_CONSTANT.PRISTINE
              });
            } else {
              this.context.setFormState({
                [this.formId]: APP_CONSTANT.PRISTINE
              });
            }
          }

          nextState.submitted = true;
        }

        nextState.submitLoading = false;

        this.setState(nextState);

        if (!this.isLoggedIn && this.saveAsGuest) {
          if (!sessionStorage.getItem('guestSubmission')) {
            const firstFormSubmissionData = [
              {
                id: this.formId,
                secureId: this.formChecksum,
                submissionId: _data.id,
                secureSubmissionId: _data.secure_id
              }
            ];
            sessionStorage.setItem(
              'guestSubmission',
              JSON.stringify(firstFormSubmissionData)
            );
          } else {
            try {
              let alreadySubmitted = false;
              const guestFormData = JSON.parse(
                sessionStorage.getItem('guestSubmission')
              ).map((item) => {
                if (Number(item.id) === Number(this.formId)) {
                  item.submissionId = _data.id;
                  item.secureSubmissionId = _data.secure_id;
                  alreadySubmitted = true;
                }
                return item;
              });
              if (!alreadySubmitted) {
                guestFormData.push({
                  id: this.formId,
                  secureId: this.formChecksum,
                  submissionId: _data.id,
                  secureSubmissionId: _data.secure_id
                });
              }
              sessionStorage.setItem(
                'guestSubmission',
                JSON.stringify(guestFormData)
              );
            } catch (error) {
            }
          }
        }
      },
      {
        method: 'POST',
        body: submission
      }
    );
  };

  handlePageChange = (page) => {
    this.setState({ page });
  };

  handleBlur = (e, requiredOverride = false, skipParent = false) => {
    let field = this.getFieldFromTarget(e.target);
    field.value = field.value || e.target.value;
    if (field.value && typeof field.value === 'string') {
      field.value = field.value.trim();
    }
    if (!isRequired(field) && field.parent && !requiredOverride && !skipParent) {
      field = field.parent;
      field.value = this.getValue(field);
    }

    let validation = validateField(field, requiredOverride);
    const updatedFields = { ...this.state.fields };

    // only show validation after submit form
    if (fieldIsType(field, 'Appointment Booking', 'group_name')) 
    {
      validation = undefined;
    }
    // validation will be undefined if no errors
    updateFieldValidation(updatedFields, field, validation); // is a mutator;

    this.setState({
      fields: updatedFields,
      formErrors: this.getFormErrorCount(updatedFields)
    });
  };

  getFormInputs = () => {
    let inputs = {};

    Object.keys(this.state.fields).reduce((acc, cur) => {
      const field = this.state.fields[cur];
      if (this.allowsInput(field)) inputs[cur] = field;
      return inputs;
    }, {});

    return inputs;
  };

  getSubmissionObject = (inputs) => {
    inputs = inputs || this.getFormInputs();
    const fields = [];
    Object.keys(inputs).reduce((acc, cur) => {
      const field = inputs[cur];
      fields.push(this.mapSafeAttributes('object', field));
      return fields;
    }, fields);

    return fields;
  };

  getUTMParametersObject = () => {
    let queryStringParams = getUTMQueryStringParameters();
    let cookieParameters = getUTMCookieParameters();

    return { ...queryStringParams, ...cookieParameters };
  };

  fieldIsVisibleOnForm = (field) => {
    if (field.type_name === 'Single Choice' || field.type_name === 'Multiple Choice') {
      return !!document.getElementsByName(field.uuid)
    }
    return !!document.getElementById(field.uuid)
  };

  validateAllInputs = (inputs) => {
    return new Promise((resolve, reject) => {
      const updatedFields = { ...this.state.fields };

      Object.keys(inputs).forEach((key) => {
        let input = inputs[key];
        const skipParentValidation =
          input.parent &&
          (fieldIsType(input.parent, 'Section Break', 'type_name') ||
            fieldIsType(input.parent, 'Appointment Booking', 'display_name') ||
            (fieldIsType(input, 'Responsible Party', 'group_name') && !fieldIsType(input, 'Sex', 'display_name')));

        if (input.parent && !skipParentValidation) {
          input = input.parent;
          input.value = this.getValue(input);
        }

        let requiredOverride =
          input.parent &&
          input.parent.display_name === 'Appointment Booking' && 'Patient';

        if (input && input.group_name === 'Appointment Booking' && (fieldIsType(input, 'Zip Code', 'display_name') || fieldIsType(input, 'Provider', 'display_name'))) {
          requiredOverride = false;
        }

        if (input && input.group_name === 'Appointment Booking' && fieldIsType(input, 'Radius', 'display_name')) {
          requiredOverride = false;
        }

        if (
          input &&
          input.parent &&
          fieldIsType(input, 'Responsible Party', 'group_name') &&
          getFieldPropertyValues(getFieldProperties(input.parent, 'common').common, 'makeRequired').makeRequired === true &&
          (fieldIsType(input, 'First Name', 'display_name') ||
            fieldIsType(input, 'Last Name', 'display_name') ||
            fieldIsType(input, 'Relationship Type', 'display_name'))
        ) {
          requiredOverride = true;
        }

        let validation = validateField(input, requiredOverride);

        if (validation && fieldIsType(input, 'Responsible Party', 'display_name')) {
          // skip group validation messages
          validation = null;
        }

        if (validation &&
          input &&
          input.group_name === 'Appointment Booking' &&
          fieldIsType(input, 'Appointment Time', 'display_name')
        ) {
          validation = AppointmentTimeValidationMessage;
        }

        if (input && fieldIsType(input, 'Mobile Consent', 'display_name')) {
          validation = validateMobileConsentField(input, updatedFields);
        }

       updatedFields[input.uuid].validationMessage = validation; 
      });

      this.setState(
        {
          fields: updatedFields,
          formErrors: this.getFormErrorCount(updatedFields)
        },
        () => (this.state.formErrors > 0 ? reject() : resolve())
      );
    });
  };

  getFieldFromTarget = (target) => this.state.fields[target.id];

  getFormErrorCount = fields => {
    fields = fields || this.state.fields;

    const inputs = this.getFormInputs();
    const submissionObject = this.getSubmissionObject(inputs);

    const isOAB = Object.values(fields)?.find((field) => field?.group_name === 'Appointment Booking')

    const fieldsToSkip = [
      AppointmentBookingUUID.appointmentBookingLocationId,
      AppointmentBookingUUID.appointmentDateTime,
    ]

    const columnsToSkip = [
      'is_autoselect_provider'
    ]

    const errorCount = Object.keys(fields).reduce((accumulator, currentKey) => {
      if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
        if (
          fields[currentKey].hasOwnProperty('validationMessage') &&
          fields[currentKey].validationMessage
        ) {
          if (
            fieldsToSkip.includes(fields[currentKey].uuid) || 
            columnsToSkip.includes(fields[currentKey].legwork_column_name)
          ) {
            return accumulator;
          }

          if (fields[currentKey].uuid === AppointmentBookingUUID.appointmentTypeId) {
            const value = submissionObject?.find((item) => item?.legwork_column_name === 'appointment_type_id')?.value;

            if (!value) {
              accumulator++;
            }
          } else if (fields[currentKey].uuid === AppointmentBookingUUID.appointmentBookingProviderId) {
            const value = submissionObject?.find((item) => item?.legwork_column_name === 'appointment_booking_provider_id')?.value;

            if (!value) {
              accumulator++;
            }
          } else if (fields[currentKey].uuid === AppointmentBookingUUID.appointmentDateTime) {
            const value = submissionObject?.find((item) => item?.legwork_column_name === 'appointment_time')?.value;

            if (!value) {
              accumulator++;
            }
          } else {
            accumulator++
          }
        }

        return accumulator;
      } else {
        if (
          fields[currentKey].hasOwnProperty('validationMessage') &&
          fields[currentKey].validationMessage
        ) {
          accumulator++;
        }

        return accumulator;
      }
    }, 0);

    return errorCount;
  };

  getValue = (field) => {
    const safeField = this.safeField(field);

    if (fieldIsType(safeField, 'Section Break') && !hasSubfields(safeField))
      return;

    return this.getFieldValues(safeField);
  };

  getFieldAttribute = (field, attribute) => this.safeField(field)[attribute];

  safeField = (field) => {
    return this.state.fields[field.uuid] || {};
  };

  allowsInput = (field) => {
    return (
      !['Section Break', 'Page Break', 'Submit'].includes(field.type_name) &&
      !field.hasOwnProperty('fields')
    );
  };

  mapFieldOptions = (field) => {
    const properties = getFieldProperties(field, 'specific');
    const propValues =
      getFieldPropertyValues(properties.specific, [
        'options',
        'displayOther',
        'other'
      ]) || [];
    const options = [...propValues.options];
    if (propValues.displayOther) options.push(propValues.other);
    return options.map(key => {
      if (key.hasOwnProperty('alt')) {
        return { [`${key.alt}`]: false };
      }
      return { [`${key}`]: false }
    });
  };

  mapSubfields = (stateField) => {
    const { fields } = this.state;
    return stateField.fields.map(
      (subfield) => fields[subfield.uuid || subfield.id].value
    );
  };

  getFieldValues = (safeField) => {
    // if field has no subfields, then return the field's value
    // otherwise recurse through subfields
    if (!hasSubfields(safeField)) return safeField.value;
    return safeField.fields.map((subfield) =>
      this.getFieldValues(this.safeField(subfield))
    );
  };

  handlePageFields = () => {
    this.updatedFormVersionFields();

    if (this.handlingFirstPage()) return this.currentPageFilter();
    if (this.formVersionHasPages()) return this.nextPageFilter();
    return this.updatedFormVersionFields();
  };

  updatedFormVersionFields = (formVersion = this.state.formVersion) => {
    if (formVersion && formVersion.object && formVersion.object.fields) {
      const fieldClone = deepClone(formVersion.object);

      updateFieldsFromCurrentState(fieldClone, this.state.fields);

      return fieldClone.fields;
    }

    return [];
  };

  async loadFamilyMembers() {
    const listFamilyMembersResponse = await axiosGet(
      `${USER_SERVICE_ROOT}/family/contacts`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        },
        method: 'GET'
      });

    let familyMemberList = [];

    // response contains a list of family member
    if ([200].includes(listFamilyMembersResponse.status)) {
      familyMemberList = listFamilyMembersResponse.data.map(c => ({
        id: c.id,
        display: `${c.nameFirst} ${c.nameLast}`,
        attributes: { ...c, birthDate: c.birthdate }
      }));
    }

    // API response does not contain the current user information
    // so we push the current user into the list
    if (this.state.userInfo) {
      familyMemberList.unshift(
        {
          id: pathOr('', ['id'])(this.state.userInfo),
          display: `${pathOr('', ['name', 'nameFirst'])(this.state.userInfo)} ${pathOr('', ['name', 'nameLast'])(this.state.userInfo)}`,
          attributes: {
            id: pathOr('', ['id'])(this.state.userInfo),
            nameFirst: pathOr('', ['name', 'nameFirst'])(this.state.userInfo),
            nameLast: pathOr('', ['name', 'nameLast'])(this.state.userInfo),
            primaryPhone: pathOr('', ['phoneNumbers', 0, 'number'])(this.state.userInfo),
            primaryEmail: pathOr('', ['emailAddress'])(this.state.userInfo),
            birthDate: pathOr('', ['birthDate'])(this.state.userInfo)
          }
        }
      );
    }

    return familyMemberList;
  }

  formVersionFields = (formVersion = this.state.formVersion) => {
    return (
      (formVersion && formVersion.object && formVersion.object.fields) || []
    );
  };

  handlingFirstPage = () => {
    const { page } = this.state;
    return this.formVersionHasPages() && page === 1;
  };

  formVersionHasPages = () => {
    const { pages } = this.state;
    return pages && pages.length > 0;
  };

  currentPageFilter = () => {
    const { pages, page } = this.state;
    return this.formVersionFields().filter(
      (field, index) => index <= pages[page - 1]
    );
  };

  nextPageFilter = () => {
    const { pages, page } = this.state;

    return this.formVersionFields().filter(
      (field, index) =>
        index > pages[page - 2] && this.lastPageFilter(pages, page, index)
    );
  };

  lastPageFilter = (pages, page, index) => {
    if (pages[page - 1]) return index <= pages[page - 1];

    return true;
  };

  setFieldProps = (field) => {
    const { pages, page, formErrors, formVersion } = this.state;
    const { readOnly, allowSubmit, isPreview } = this.props;
    const isReview = !allowSubmit && !isPreview;

    const props = {
      uuid: field.uuid,
      field,
      isRenderedField: true,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      value: this.getValue(field),
      validationMessage: this.getFieldAttribute(field, 'validationMessage'),
      readOnly,
      isPreview,
      isReview
    };

    // the appointment booking field needs the account id in order to properly send API requests
    if (field.display_name === 'Appointment Booking') {
      props.accountId = formVersion.account_id;
      props.generalSettingParams = this.state.generalSettingParams;
    }

    if (hasFieldByName(field, 'Responsible Party')) {
      props.relationshipTypes = this.state.relationshipTypes;
    }

    if (field.type_name === 'Submit') {
      props.onFieldClick = (e) => this.handleSubmit(e);
      if (this.type === APP_CONSTANT.APPOINTMENT_BOOKING) {
        props.displayReset = true;
        props.onFieldResetClick = (e) => this.handleReset(e);
      }
      props.pageNum = page;
      props.displayPrevious = page > 1;
      props.onPageChange = this.handlePageChange;
    } else if (field.type_name === 'Page Break') {
      props.pageNum = page;
      props.displayPrevious = page > 1;
      props.displayNext = page <= pages.length;
      props.onPageChange = this.handlePageChange;
    }

    return props;
  };

  canSave = () => {
    return (
      this.hasProp('saveFlag') && this.hasProp('onSave') && this.props.saveFlag
    );
  };

  handleGetSubmission = () => {
    this.setState({ isSaving: false });
    // get all input fields
    const inputs = this.getFormInputs();

    // validate fields before allowing submission
    this.validateAllInputs(inputs)
      .then(() =>
        this.props.onSave(undefined, this.getSubmissionObject(inputs))
      )
      .catch(() => this.props.onSave(true));
  };

  isRedirect = () => (this.state.formVersion || {}).is_redirect;

  shouldDisplayThankYou = () => this.state.submitted && !this.isRedirect();

  shouldRedirect = () => this.state.submitted && this.isRedirect();

  handleAcknowledgeError = () => {
    if (this.state.errorConfirmationAction) {
      this.state.errorConfirmationAction();
    } else {
      this.setState({ dataProcessingError: null });
    }
  };

  handleRedirect = () =>
  (window.location =
    this.state.formVersion && this.state.formVersion.redirect_url);

  getDefaultDropdownValue = (field) => {
    const { options } =
      getFieldPropertyValues(
        getFieldProperties(field, 'specific').specific,
        'options'
      ) || [];

    return options && options.length > 0 ? options[0] : '';
  };

  handleConfirmUsingLatestUserInfo = () => this.setState({ isConfirmedUsingLatestUserInfo: true });

  closeUsingLatestUserInfoPopup = () => this.setState({ showConfirmUsingLatestUserInfo: false });

  render() {
    const { id, referer } = this.props;
    const { formVersion, formErrors, dataProcessingError, showConfirmUsingLatestUserInfo, isLoadingPatientInfo, oabSubmissionConflictError } = this.state;
    const { VALIDATION_ERRORS, VALIDATION_ERROR, OAB_SUBMISSION_CONFLICT_ERROR } = Messages;

    if (this.shouldDisplayThankYou())
      return (
        <ThankYou
          referer={referer}
          message={this.state.thankYouMessage}
        />
      );
    if (this.shouldRedirect()) this.handleRedirect();
    if (dataProcessingError)
      return (
        <ErrorContainer
          message={dataProcessingError}
          onClick={this.handleAcknowledgeError}
        />
      );

    const pageFields = this.handlePageFields();
    const form = (
      <form id={id}>
        {pageFields?.map((field) => {
          const props = {
            ...this.setFieldProps(field),
            familyMemberList: this.state.familyMemberList,
            updatedAppointmentBookingSlots: this.state.updatedAppointmentBookingSlots,
            oabSubmissionConflictError: this.state.oabSubmissionConflictError,
            handleOabTab: (e) => this.handleOabTab(e),
            activeOABTab: this.state.activeOABTab
          };

          return (
            <div key={field.uuid || field.id}>
              {(!this.state.isResetOabForm) ? (getComponent(field, props)) : <div />}
            </div>
          );
        })}
        {formErrors > 0 && (
          <div className="error-submit">
            <div className="control-group error">
              <span className="help-block">
                {formErrors > 1
                  ? VALIDATION_ERRORS.replace('{{count}}', formErrors)
                  : VALIDATION_ERROR.replace('{{count}}', formErrors)}
              </span>
            </div>
          </div>
        )}

        {formErrors === 0 && oabSubmissionConflictError > 0 && (
          <div className="error-submit">
            <div className="control-group error">
              <span className="help-block">
                {OAB_SUBMISSION_CONFLICT_ERROR}
              </span>
            </div>
          </div>
        )}
        {!formVersion && <h3>{`Loading Legwork form ${id}. . .`}</h3>}
      </form>
    );

    return (
      <>
        <ConfirmationDialog
          open={showConfirmUsingLatestUserInfo}
          confirmHandler={this.handleConfirmUsingLatestUserInfo}
          cancelHandler={this.closeUsingLatestUserInfoPopup}
          textTitle={t('patientDocument.confirmUsingLatestUserInfo.title')}
          textDescription={t(
            'patientDocument.confirmUsingLatestUserInfo.detail'
          )}
        />
        {(this.type === APP_CONSTANT.APPOINTMENT_BOOKING && this.role === APP_CONSTANT.ROLE_LEGAL_GUARDIAN) ? (
          <LoadingContainer isLoading={isLoadingPatientInfo} isOverlay={true}>
            {form}
          </LoadingContainer>
        ) : form}
      </>
    );
  }
}

FormRenderer.defaultProps = {
  readOnly: false,
  saveFlag: false,
  allowSubmit: true,
  isPreview: false,
  isShowInformation: false
};

const isRequired = (field) => {
  return (
    getFieldPropertyValues(
      getFieldProperties(field, 'common').common,
      'makeRequired'
    ).makeRequired === true
  );
};

const updateFieldValidation = (updatedFields, field, validation) => {
  updatedFields[field.uuid].validationMessage = validation;
};

const updateFieldsFromCurrentState = (outdatedFields, fieldDictionary) => {
  if (!outdatedFields || !outdatedFields.fields) {
    return;
  }

  for (let i = 0; i < outdatedFields.fields.length; i++) {
    outdatedFields.fields[i] =
      fieldDictionary[outdatedFields.fields[i].uuid] ||
      outdatedFields.fields[i];

    updateFieldsFromCurrentState(outdatedFields.fields[i], fieldDictionary);
  }
};

const deepClone = (el) => {
  if (typeof el !== 'object') {
    return el;
  }
  if (Array.isArray(el)) {
    return el.map((element) => deepClone(element));
  }
  for (const key in el) {
    if (key === 'fields') {
      el[key] = deepClone(el[key]);
    }
  }
  return { ...el };
};

const ErrorContainer = ({ message, onClick }) => (
  <div style={{ width: '100%' }}>
    <img src={ErrorImg} alt="Logo" className='img-error' style={{ width: '80%' }} />
    {/* <button
      className="btn btn-primary"
      onClick={onClick}
      style={{ marginLeft: '50%', width: '50px' }}
    >
      OK
    </button> */}

    <PrimaryButton
      onClick={onClick}
      variant="contained"
      isShowIcon={false}
      customClass={true}
      title={t('general.ok')}
    />
  </div>
);

export default withCookies(FormRenderer);
